<template>
  <ul>
    <li
      :key="item.authName"
      v-for="item in data"
      :class="`${item.children ? 'children' : ''}${item.interface ? ' interface' : ''}`"
    >
      <a-checkbox
        :value="item.key"
        :checked="checkedList.includes(item.key)"
        @change="callback"
        class="checked-menu-title"
      >
        {{ item.label }}
        <!-- <span style="color:#ccc;font-size:12px;">(key:{{ item.key }})</span> -->
      </a-checkbox>

      <dl v-if="item.interface">
        <dd v-for="item2 in item.interface" :key="item2.authName">
          <a-checkbox
            :value="item2.key"
            :checked="checkedList.includes(item2.key)"
            @change="callback"
          >
            {{ item2.label }}
            <!-- <span style="color:#ccc;font-size:12px;">
              (key:{{ item2.key }})
            </span> -->
          </a-checkbox>
        </dd>
      </dl>

      <!-- 递归调用自己 -->
      <AuthItem
        :data="item.children"
        v-if="item.children"
        :callback="callback"
        :checkedList="checkedList"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AuthItem',
  props: {
    data: {
      type: Array,
      default: () => [],
    },

    checkedList: {
      type: Array,
      default: () => [],
    },

    callback: {
      type: Function,
      default: () => {},
    },
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.item-list {
  ul {
    padding-left: 20px;
    ::v-deep li {
      border-bottom: #eee solid 1px;
      padding: 15px 0 15px 0;
      &:last-child {
        border: none;
      }
      &.children {
        ul {
          padding-top: 5px;
        }
      }

      &.interface {
        padding-bottom: 10px;
      }

      // 菜单级样式
      > label {
        span {
          // font-size: 14px;
          color: #e91e63;
        }
      }

      dl {
        margin: 20px 30px 0;
        display: flex;
        flex-wrap: wrap;

        dd {
          min-width: 170px;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
